import { IMedicalPrescriptionMappingConfiguration } from "src/app/ui/models/domains/pbm/Benefit/imedical-prescription-mapping-configuration";
import { MedicalPrescriptionConfiguration } from "src/app/ui/models/domains/pbm/Benefit/medical-prescription-configuration";
import { MedicalPrescriptionMappingConfiguration } from "src/app/ui/models/domains/pbm/Benefit/medical-prescription-mapping-configuration";
import { MedicalPrescriptionValidity } from "src/app/ui/models/domains/pbm/Benefit/medical-prescription-validity";
import { AbstractParser } from "../../parser";
export class MedicalPrescriptionConfigurationParser extends AbstractParser<MedicalPrescriptionConfiguration> {
  parse(payload: any): MedicalPrescriptionConfiguration {
    const medicalPrescriptionConfiguration = new MedicalPrescriptionConfiguration();
    medicalPrescriptionConfiguration.setKey(payload.Key);
    medicalPrescriptionConfiguration.setCompanyFiscalNumber(payload.CompanyFiscalNumber);
    medicalPrescriptionConfiguration.setEnabled(payload.Enabled);
    medicalPrescriptionConfiguration.setRequiredScan(payload.RequiredScan);
    medicalPrescriptionConfiguration.setPurchaseRequiredScan(payload.PurchaseRequiredScan);
    medicalPrescriptionConfiguration.setMedicalPrescriptionMappingConfiguration(
      this.parseMedicalPrescriptionMappingConfiguration(payload.MedicalPrescriptionMappingConfiguration),
    );
    return medicalPrescriptionConfiguration;
  }

  private parseMedicalPrescriptionMappingConfiguration(payload: any): Array<IMedicalPrescriptionMappingConfiguration> {
    const medicalPrescriptionMappingConfiguration: Array<IMedicalPrescriptionMappingConfiguration> = [];

    payload.map((item) => {
      const medicalPrescriptionConfiguration = new MedicalPrescriptionMappingConfiguration();
      medicalPrescriptionConfiguration.setMedicalPrescriptionValidity(this.parseMedicalPrescriptionValidity(item.MedicalPrescriptionValidityKey));
      medicalPrescriptionConfiguration.setValidDaysPeriod(item.ValidDaysPeriod);
      medicalPrescriptionMappingConfiguration.push(medicalPrescriptionConfiguration);
    });

    return medicalPrescriptionMappingConfiguration;
  }

  private parseMedicalPrescriptionValidity(key: string): MedicalPrescriptionValidity {
    const medicalPrescriptionValidity = new MedicalPrescriptionValidity();
    medicalPrescriptionValidity.setKey(key);
    medicalPrescriptionValidity.setUseType(null);
    medicalPrescriptionValidity.setDaysValidity(null);
    return medicalPrescriptionValidity;
  }
}
